import {
  DOCUMENT__INITIALIZE,
  DOCUMENT_DATA__FETCH_REQUEST,
  DOCUMENT_DATA__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAction } from '@app/store/document/actions';
import { DocumentDataAction } from '@app/store/document/data/actions';
import Document from '@app/store/document/Document';

type DocumentDataState = Document | null;

const initialState: DocumentDataState = null;

export default function reducer(
  state: DocumentDataState = initialState,
  action: DocumentAction | DocumentDataAction
) {
  switch (action.type) {
    case DOCUMENT_DATA__FETCH_REQUEST:
      return initialState;
    case DOCUMENT_DATA__FETCH_SUCCESS:
      if (action.payload.document) {
        const { document } = action.payload;
        return document;
      }
      return initialState;
    case DOCUMENT__INITIALIZE:
      return initialState;
    default:
      return state;
  }
}
